module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('h1', {
    staticClass: "davi-curs font-red",
    domProps: {
      "innerHTML": _vm._s(_vm.textTitle)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33e74b2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Titlered.vue
// module id = 958
// module chunks = 1